export enum ViewColumnsAddBlock {
  Root = 'ViewColumnsAdd',
}
